import { ROUTES } from "./";

export const MANAGE_PLAN_ROUTES = {
  CREATE_PLAN: `${ROUTES.MANAGE_PLAN}/create-plan`,
  BASIC_DETAILS: `${ROUTES.MANAGE_PLAN}/plan-details`,
  SPONSOR: `${ROUTES.MANAGE_PLAN}/sponsor`,
  ADD_SPONSOR: `${ROUTES.MANAGE_PLAN}/add-sponsor`,
  SPONSOR_INFORMATION: `${ROUTES.MANAGE_PLAN}/sponsor-information`,
  TRUSTEE: `${ROUTES.MANAGE_PLAN}/trustee`,
  ADD_TRUSTEE: `${ROUTES.MANAGE_PLAN}/add-trustee`,
  ADD_TRUSTEE_MASTER: `${ROUTES.MANAGE_PLAN}/add-trustee-master`,
  MANAGE_TRUSTEE: `${ROUTES.MANAGE_PLAN}/manage-trustee`,
  CUSTODIAN: `${ROUTES.MANAGE_PLAN}/custodian`,
  ADD_CUSTODIAN: `${ROUTES.MANAGE_PLAN}/add-custodian`,
  ADD_CUSTODIAN_MASTER: `${ROUTES.MANAGE_PLAN}/add-custodian-master`,
  MANAGE_CUSTODIAN: `${ROUTES.MANAGE_PLAN}/manage-custodian`,
  ADVISOR: `${ROUTES.MANAGE_PLAN}/advisor`,
  ADD_ADVISOR: `${ROUTES.MANAGE_PLAN}/add-advisor`,
  ADD_ADVISOR_MASTER: `${ROUTES.MANAGE_PLAN}/add-advisor-master`,
  MANAGE_ADVISOR: `${ROUTES.MANAGE_PLAN}/manage-advisor`,
  COMPLIANCE: `${ROUTES.MANAGE_PLAN}/compliance`,
  MANAGE_SOURCES: `${ROUTES.MANAGE_PLAN}/manage-sources`,
  MANAGE_SOURCES_MASTER: `${ROUTES.MANAGE_PLAN}/sources-master`,
  MANAGE_SOURCES_NEW: `${ROUTES.MANAGE_PLAN}/sources-new`,
  VIEW_SOURCES_MASTER: `${ROUTES.MANAGE_PLAN}/master-sources-view`,
  MANAGE_SOURCES_HISTORY: `${ROUTES.MANAGE_PLAN}/sources-history`,
  MANAGE_SOURCES_ADD_ADDITIONAL_RULES: `${ROUTES.MANAGE_PLAN}/add-additional-rules`,
  ELIGIBILITY: `${ROUTES.MANAGE_PLAN}/eligibility`,
  ADD_ELIGIBILITY: `${ROUTES.MANAGE_PLAN}/add-eligibility`,
  ADDITIONAL_ELIGIBILITY_RULE: `${ROUTES.MANAGE_PLAN}/additional-eligibility-rule`,
  ALLOCATION: `${ROUTES.MANAGE_PLAN}/allocation`,
  ADD_SOURCE_ALLOCATION: `${ROUTES.MANAGE_PLAN}/add-source-allocation`,
  VESTING: `${ROUTES.MANAGE_PLAN}/vesting`,
  ADD_VESTING: `${ROUTES.MANAGE_PLAN}/add-vesting`,
  ADD_VESTING_RULE: `${ROUTES.MANAGE_PLAN}/add-addtional-vesting-rule`,
  FORFEITURE: `${ROUTES.MANAGE_PLAN}/forfeiture`,
  MANAGE_FUNDING: `${ROUTES.MANAGE_PLAN}/manage-funding`,
  MANAGE_FUNDING_DETAIL: `${ROUTES.MANAGE_PLAN}/funding-detail`,
  MANAGE_RETIREMENT: `${ROUTES.MANAGE_PLAN}/manage-retirement`,
  ENROLLMENT: `${ROUTES.MANAGE_PLAN}/enrollment`,
  ADDITIONAL_AUTO_ENROLLMENT: `${ROUTES.MANAGE_PLAN}/additional-auto-enrollment`,
  ENTRYDATE: `${ROUTES.MANAGE_PLAN}/Entrydate`,
  YEARS_OF_SERVICE: `${ROUTES.MANAGE_PLAN}/years-of-service`,
  SOURCE_ENROLLMENT: `${ROUTES.MANAGE_PLAN}/source-enrollment`,
  ROLLOVER: `${ROUTES.MANAGE_PLAN}/rollover`,
  MANAGE_COMPENSATION: `${ROUTES.MANAGE_PLAN}/manage-compensation`,
  MANAGE_PLAN_COMPENSATION_CATEGORY: `${ROUTES.MANAGE_PLAN}/manage-compensation`,
  MANAGE_SOURCE_COMPENSATION: `${ROUTES.MANAGE_PLAN}/source-compensation`,
  DISTRIBUTIONS: `${ROUTES.MANAGE_PLAN}/distributions`,
  ADD_DISTRIBUTIONS: `${ROUTES.MANAGE_PLAN}/add-distributions`,
  TRANSFER: `${ROUTES.MANAGE_PLAN}/transfer`,
  LOANS: `${ROUTES.MANAGE_PLAN}/loans`,
  MANAGE_INVESTMENTS_PLAN: `${ROUTES.MANAGE_PLAN}/manage-investment-plan`,
  MANAGE_INVESTMENTS_MASTER: `${ROUTES.MANAGE_PLAN}/manage-investment-master`,
  ADD_INVESTMENTS: `${ROUTES.MANAGE_PLAN}/add-investments`,
  ADD_INVESTMENTS_RESTRICTIONS: `${ROUTES.MANAGE_PLAN}/add-investment-restrictions`,
  VIEW_INV_ASSOCIATED_PLANS: `${ROUTES.MANAGE_PLAN}/assiciated-plans`,
  VIEW_INV_RESTRICTION_HISTORY: `${ROUTES.MANAGE_PLAN}/restrictions-history`,
  ADD_LOANS: `${ROUTES.MANAGE_PLAN}/add-loans`,
  REVIEW: `${ROUTES.MANAGE_PLAN}/review`,
  IRSLIMIT: `${ROUTES.MANAGE_PLAN}/irslimit`,
  ENTRYDATECLASSIFICATION: `${ROUTES.MANAGE_PLAN}/entryDateClassification`,
  ADD_ENTRYDATECLASSIFICATION: `${ROUTES.MANAGE_PLAN}/add-entryDateClassification`,
  ADDITIONAL_ENTRYDATECLASSIFICATION_RULE: `${ROUTES.MANAGE_PLAN}/additional-entryDateClassification-rule`,
  ACCOUNT_BALANCE: `${ROUTES.MANAGE_PLAN}/account-balance`,
  CLEARING_PARTNER: `${ROUTES.MANAGE_PLAN}/clearing-partner`,
  ADD_CLEARING_PARTNER: `${ROUTES.MANAGE_PLAN}/add-clearing-partner`,
};

export const REVIEW_SCREEN_DATA_MAPPING = {
  BASIC_DETAILS: "basicDetails",
  SPONSOR: "sponsor",
  TRUSTEE: "trustee",
  CUSTODIAN: "custodian",
  ADVISOR: "advisor",
  COMPLIANCE: "compliance",
  SOURCES: "sources",
  ELIGIBILITY: "eligibility",
  ALLOCATIONS: "allocation",
  VESTING: "vesting",
  FORFEITURE: "forfeiture",
  FUNDING: "manageFundings",
  ENROLLMENT: "enrollment",
  // ENTRYDATE: "entryDate",
  ROLLOVER: "rollover",
  RETIREMENT: "manageRetirement",
  COMPENSATION: "manageCompensation",
  DISTRIBUTIONS: "distributions",
  TRANSFERS: "transfer",
  LOANS: "loans",
  INVESTMENTS: "manageInvestmentsPlan",
  REVIEW: "review",
  IRSLIMIT: `irslimit`,
  ENTRYDATECLASSIFICATION: "entryDate",
  YEARS_OF_SERVICE: "yearsOfService",
  CLEARING_PARTNER: "clearingPartner",
};

export const MANAGE_PLAN_MENU = [
  {
    id: "createPlan",
    label: "Create Plan",
    path: MANAGE_PLAN_ROUTES.CREATE_PLAN,
    contentHeader: "Create Plan",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.BASIC_DETAILS,
    label: "Plan Details",
    path: MANAGE_PLAN_ROUTES.BASIC_DETAILS,
    contentHeader: "Plan Details",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.SOURCES,
    label: "Sources",
    path: MANAGE_PLAN_ROUTES.MANAGE_SOURCES,
    contentHeader: "Manage Sources",
    breadCrumbs: [],
    childRoutes: [
      MANAGE_PLAN_ROUTES.MANAGE_SOURCES_MASTER,
      MANAGE_PLAN_ROUTES.MANAGE_SOURCES_NEW,
      MANAGE_PLAN_ROUTES.MANAGE_SOURCES_ADD_ADDITIONAL_RULES,
      MANAGE_PLAN_ROUTES.VIEW_SOURCES_MASTER,
      MANAGE_PLAN_ROUTES.MANAGE_SOURCES_HISTORY,
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.SPONSOR,
    label: "Sponsor",
    path: MANAGE_PLAN_ROUTES.SPONSOR,
    contentHeader: "Sponsor",
    breadCrumbs: [],
    childRoutes: [
      MANAGE_PLAN_ROUTES.ADD_SPONSOR,
      MANAGE_PLAN_ROUTES.SPONSOR_INFORMATION,
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.TRUSTEE,
    label: "Trustee",
    path: MANAGE_PLAN_ROUTES.TRUSTEE,
    contentHeader: "Manage Trustee",
    breadCrumbs: [],
    childRoutes: [
      MANAGE_PLAN_ROUTES.ADD_TRUSTEE,
      MANAGE_PLAN_ROUTES.ADD_TRUSTEE_MASTER,
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.CLEARING_PARTNER,
    label: "Clearing Partner",
    path: MANAGE_PLAN_ROUTES.CLEARING_PARTNER,
    contentHeader: "Manage Clearing Partner",
    breadCrumbs: [],
    childRoutes: [MANAGE_PLAN_ROUTES.ADD_CLEARING_PARTNER],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ADVISOR,
    label: "Advisor",
    path: MANAGE_PLAN_ROUTES.ADVISOR,
    contentHeader: "Manage Advisor",
    breadCrumbs: [],
    childRoutes: [
      MANAGE_PLAN_ROUTES.ADD_ADVISOR,
      MANAGE_PLAN_ROUTES.ADD_ADVISOR_MASTER,
      MANAGE_PLAN_ROUTES.MANAGE_ADVISOR,
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.INVESTMENTS,
    label: "Investments",
    path: MANAGE_PLAN_ROUTES.MANAGE_INVESTMENTS_PLAN,
    contentHeader: "Manage Investments",
    breadCrumbs: [],
    childRoutes: [
      MANAGE_PLAN_ROUTES.MANAGE_INVESTMENTS_MASTER,
      MANAGE_PLAN_ROUTES.ADD_INVESTMENTS,
      MANAGE_PLAN_ROUTES.ADD_INVESTMENTS_RESTRICTIONS,
      MANAGE_PLAN_ROUTES.VIEW_RESTRICTIONS_HISTORY,
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ELIGIBILITY,
    label: "Eligibility",
    path: MANAGE_PLAN_ROUTES.ELIGIBILITY,
    contentHeader: "Eligibility",
    breadCrumbs: [],
    childRoutes: [
      MANAGE_PLAN_ROUTES.ADD_ELIGIBILITY,
      MANAGE_PLAN_ROUTES.ADDITIONAL_ELIGIBILITY_RULE,
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ENROLLMENT,
    label: "Enrollment",
    path: MANAGE_PLAN_ROUTES.ENROLLMENT,
    contentHeader: "Enrollment",
    breadCrumbs: [],
    childRoutes: [
      MANAGE_PLAN_ROUTES.SOURCE_ENROLLMENT,
      MANAGE_PLAN_ROUTES.ADDITIONAL_AUTO_ENROLLMENT,
    ],
  },
  // {
  //   id: REVIEW_SCREEN_DATA_MAPPING.ENTRYDATE,
  //   label: "Entry Date",
  //   path: MANAGE_PLAN_ROUTES.ENTRYDATE,
  //   contentHeader: "Entry Date",
  //   breadCrumbs: [],
  //   childRoutes: [MANAGE_PLAN_ROUTES.SOURCE_ENROLLMENT],
  // },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ENTRYDATECLASSIFICATION,
    label: "Entry Date",
    path: MANAGE_PLAN_ROUTES.ENTRYDATECLASSIFICATION,
    contentHeader: "Entry Date",
    breadCrumbs: [],
    childRoutes: [
      MANAGE_PLAN_ROUTES.ADD_ENTRYDATECLASSIFICATION,
      MANAGE_PLAN_ROUTES.ADDITIONAL_ENTRYDATECLASSIFICATION_RULE,
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.YEARS_OF_SERVICE,
    label: "Years Of Service",
    path: MANAGE_PLAN_ROUTES.YEARS_OF_SERVICE,
    contentHeader: "Years Of Service",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.VESTING,
    label: "Vesting",
    path: MANAGE_PLAN_ROUTES.VESTING,
    contentHeader: "Vesting",
    breadCrumbs: [],
    childRoutes: [
      MANAGE_PLAN_ROUTES.ADD_VESTING,
      MANAGE_PLAN_ROUTES.ADD_VESTING_RULE,
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ALLOCATIONS,
    label: "Allocations",
    path: MANAGE_PLAN_ROUTES.ALLOCATION,
    contentHeader: "Allocations",
    breadCrumbs: [],
    childRoutes: [MANAGE_PLAN_ROUTES.ADD_SOURCE_ALLOCATION],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.COMPENSATION,
    label: "Compensation",
    path: MANAGE_PLAN_ROUTES.MANAGE_COMPENSATION,
    contentHeader: "Compensation",
    breadCrumbs: [],
    childRoutes: [MANAGE_PLAN_ROUTES.MANAGE_SOURCE_COMPENSATION],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.RETIREMENT,
    label: "Retirement",
    path: MANAGE_PLAN_ROUTES.MANAGE_RETIREMENT,
    contentHeader: "Retirement",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.LOANS,
    label: "Loans",
    path: MANAGE_PLAN_ROUTES.LOANS,
    contentHeader: "Loans",
    breadCrumbs: [],
    childRoutes: [MANAGE_PLAN_ROUTES.ADD_LOANS],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.DISTRIBUTIONS,
    label: "Distributions",
    path: MANAGE_PLAN_ROUTES.DISTRIBUTIONS,
    contentHeader: "Distributions",
    breadCrumbs: [],
    childRoutes: [
      MANAGE_PLAN_ROUTES.DISTRIBUTIONS,
      MANAGE_PLAN_ROUTES.ADD_DISTRIBUTIONS,
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ROLLOVER,
    label: "Rollovers",
    path: MANAGE_PLAN_ROUTES.ROLLOVER,
    contentHeader: "Rollovers",
    breadCrumbs: [],
    childRoutes: [MANAGE_PLAN_ROUTES.ROLLOVER],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.TRANSFERS,
    label: "Transfers",
    path: MANAGE_PLAN_ROUTES.TRANSFER,
    contentHeader: "Transfers",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.FUNDING,
    label: "Funding",
    path: MANAGE_PLAN_ROUTES.MANAGE_FUNDING,
    contentHeader: "Funding",
    breadCrumbs: [],
    childRoutes: [MANAGE_PLAN_ROUTES.MANAGE_FUNDING_DETAIL],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.IRSLIMIT,
    label: "IRS Limit",
    path: MANAGE_PLAN_ROUTES.IRSLIMIT,
    contentHeader: "IRS LIMITS",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: "review",
    label: "Review",
    path: MANAGE_PLAN_ROUTES.REVIEW,
    contentHeader: "Plan Status",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.COMPLIANCE,
    label: "Compliance",
    path: MANAGE_PLAN_ROUTES.COMPLIANCE,
    contentHeader: "Compliance",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.FORFEITURE,
    label: "Forfeiture",
    path: MANAGE_PLAN_ROUTES.FORFEITURE,
    contentHeader: "Forfeiture",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: "accountBalance",
    label: "Account Balance",
    path: MANAGE_PLAN_ROUTES.ACCOUNT_BALANCE,
    contentHeader: "Account Balance",
    breadCrumbs: [],
    childRoutes: [],
  },
];

export const ALL_MANAGE_PLAN_ROUTES = [
  ...MANAGE_PLAN_MENU,
  {
    id: REVIEW_SCREEN_DATA_MAPPING.BASIC_DETAILS,
    contentHeader: "Basic Details",
    path: MANAGE_PLAN_ROUTES.BASIC_DETAILS,
    breadCrumbs: [
      {
        label: "Basic Details",
        link: MANAGE_PLAN_ROUTES.BASIC_DETAILS,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.SPONSOR,
    contentHeader: "Sponsor",
    path: MANAGE_PLAN_ROUTES.SPONSOR,
    breadCrumbs: [
      {
        label: "Sponsor",
        link: MANAGE_PLAN_ROUTES.SPONSOR,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.SPONSOR,
    contentHeader: "Add Sponsor",
    path: MANAGE_PLAN_ROUTES.ADD_SPONSOR,
    breadCrumbs: [
      {
        label: "Manage Sponsor",
        link: MANAGE_PLAN_ROUTES.SPONSOR,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.SPONSOR,
    contentHeader: "Information Sponsor",
    path: MANAGE_PLAN_ROUTES.SPONSOR_INFORMATION,
    breadCrumbs: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.TRUSTEE,
    contentHeader: "Manage Trustee",
    path: MANAGE_PLAN_ROUTES.TRUSTEE,
    breadCrumbs: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.TRUSTEE,
    contentHeader: "Add Trustee",
    path: MANAGE_PLAN_ROUTES.ADD_TRUSTEE,
    breadCrumbs: [
      {
        label: "Manage Trustee",
        link: MANAGE_PLAN_ROUTES.TRUSTEE,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.TRUSTEE,
    contentHeader: "Add Trustee",
    path: MANAGE_PLAN_ROUTES.ADD_TRUSTEE_MASTER,
    breadCrumbs: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.TRUSTEE,
    contentHeader: "Manage Trustee",
    path: MANAGE_PLAN_ROUTES.MANAGE_TRUSTEE,
    breadCrumbs: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.CUSTODIAN,
    contentHeader: "Custodian",
    path: MANAGE_PLAN_ROUTES.CUSTODIAN,
    breadCrumbs: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.CUSTODIAN,
    contentHeader: "Add Custodian",
    path: MANAGE_PLAN_ROUTES.ADD_CUSTODIAN,
    breadCrumbs: [
      {
        label: "Manage Custodian",
        link: MANAGE_PLAN_ROUTES.CUSTODIAN,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.CUSTODIAN,
    contentHeader: "Add Custodian",
    path: MANAGE_PLAN_ROUTES.ADD_CUSTODIAN_MASTER,
    breadCrumbs: [
      {
        label: "Add Custodian",
        link: MANAGE_PLAN_ROUTES.ADD_CUSTODIAN_MASTER,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.CUSTODIAN,
    contentHeader: "Manage Custodian",
    path: MANAGE_PLAN_ROUTES.MANAGE_CUSTODIAN,
    breadCrumbs: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ADVISOR,
    contentHeader: "Manage Advisor",
    path: MANAGE_PLAN_ROUTES.ADVISOR,
    breadCrumbs: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ADVISOR,
    contentHeader: "Add Advisor",
    path: MANAGE_PLAN_ROUTES.ADD_ADVISOR,
    breadCrumbs: [
      {
        label: "Manage Advisor",
        link: MANAGE_PLAN_ROUTES.ADVISOR,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ADVISOR,
    contentHeader: "Add Advisor",
    path: MANAGE_PLAN_ROUTES.ADD_ADVISOR_MASTER,
    breadCrumbs: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ADVISOR,
    contentHeader: "Manage Advisor",
    path: MANAGE_PLAN_ROUTES.MANAGE_ADVISOR,
    breadCrumbs: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.SOURCES,
    label: "",
    path: MANAGE_PLAN_ROUTES.MANAGE_SOURCES_MASTER,
    contentHeader: "Manage Sources",
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.SOURCES,
    label: "",
    path: MANAGE_PLAN_ROUTES.MANAGE_SOURCES_NEW,
    contentHeader: "Add Sources",
    breadCrumbs: [
      {
        label: "Manage Sources",
        link: MANAGE_PLAN_ROUTES.MANAGE_SOURCES,
      },
    ],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.SOURCES,
    label: "",
    path: MANAGE_PLAN_ROUTES.VIEW_SOURCES_MASTER,
    contentHeader: "Source",
    breadCrumbs: [
      {
        label: "Manage Sources",
        link: MANAGE_PLAN_ROUTES.MANAGE_SOURCES,
      },
    ],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.SOURCES,
    label: "",
    path: MANAGE_PLAN_ROUTES.MANAGE_SOURCES_HISTORY,
    contentHeader: "History",
    breadCrumbs: [
      {
        label: "Manage Sources",
        link: MANAGE_PLAN_ROUTES.MANAGE_SOURCES,
      },
    ],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.SOURCES,
    label: "",
    path: MANAGE_PLAN_ROUTES.MANAGE_SOURCES_ADD_ADDITIONAL_RULES,
    contentHeader: "Additional Allocation Rule",
    breadCrumbs: [
      {
        label: "Manage Sources",
        link: MANAGE_PLAN_ROUTES.MANAGE_SOURCES,
      },
      {
        label: "Sources",
        link: MANAGE_PLAN_ROUTES.MANAGE_SOURCES_MASTER, // TODO: Map to sources screen
      },
    ],
    childRoutes: [],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ELIGIBILITY,
    contentHeader: "Eligibility",
    path: MANAGE_PLAN_ROUTES.ELIGIBILITY,
    breadCrumbs: [
      {
        label: "Eligibility",
        link: MANAGE_PLAN_ROUTES.ELIGIBILITY,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ELIGIBILITY,
    contentHeader: "Add Eligibility Rule",
    path: MANAGE_PLAN_ROUTES.ADD_ELIGIBILITY,
    breadCrumbs: [
      {
        label: "Eligibility",
        link: MANAGE_PLAN_ROUTES.ELIGIBILITY,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ELIGIBILITY,
    contentHeader: "Additional Eligibility Rule",
    path: MANAGE_PLAN_ROUTES.ADDITIONAL_ELIGIBILITY_RULE,
    breadCrumbs: [
      {
        label: "Eligibility",
        link: MANAGE_PLAN_ROUTES.ELIGIBILITY,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ENTRYDATECLASSIFICATION,
    contentHeader: "Entry Date",
    path: MANAGE_PLAN_ROUTES.ENTRYDATECLASSIFICATION,
    breadCrumbs: [
      {
        label: "Entry Date",
        link: MANAGE_PLAN_ROUTES.ENTRYDATECLASSIFICATION,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ENTRYDATECLASSIFICATION,
    contentHeader: "Add Entry Date Rule",
    path: MANAGE_PLAN_ROUTES.ADD_ENTRYDATECLASSIFICATION,
    breadCrumbs: [
      {
        label: "Entry Date",
        link: MANAGE_PLAN_ROUTES.ENTRYDATECLASSIFICATION,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ENTRYDATECLASSIFICATION,
    contentHeader: "Additional Entry Date Rule",
    path: MANAGE_PLAN_ROUTES.ADDITIONAL_ENTRYDATECLASSIFICATION_RULE,
    breadCrumbs: [
      {
        label: "Entry Date",
        link: MANAGE_PLAN_ROUTES.ENTRYDATECLASSIFICATION,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.YEARS_OF_SERVICE,
    contentHeader: "Years of Service",
    path: MANAGE_PLAN_ROUTES.YEARS_OF_SERVICE,
    breadCrumbs: [
      {
        label: "Years of Service",
        link: MANAGE_PLAN_ROUTES.YEARS_OF_SERVICE,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.COMPENSATION,
    contentHeader: "Add Source Compensation",
    path: MANAGE_PLAN_ROUTES.MANAGE_SOURCE_COMPENSATION,
    breadCrumbs: [
      {
        label: "Compensation",
        link: MANAGE_PLAN_ROUTES.MANAGE_COMPENSATION,
      },
      {
        lable: "Source Compensation",
        link: MANAGE_PLAN_ROUTES.MANAGE_SOURCE_COMPENSATION,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ALLOCATIONS,
    contentHeader: "Allocations",
    path: MANAGE_PLAN_ROUTES.ALLOCATION,
    breadCrumbs: [
      {
        label: "Allocations",
        link: MANAGE_PLAN_ROUTES.ALLOCATION,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ALLOCATIONS,
    contentHeader: "Allocations",
    path: MANAGE_PLAN_ROUTES.ADD_SOURCE_ALLOCATION,
    breadCrumbs: [
      {
        label: "Add Source Allocation",
        link: MANAGE_PLAN_ROUTES.ADD_SOURCE_ALLOCATION,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.VESTING,
    contentHeader: "Vesting",
    path: MANAGE_PLAN_ROUTES.VESTING,
    breadCrumbs: [
      {
        label: "Vesting",
        link: MANAGE_PLAN_ROUTES.VESTING,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.VESTING,
    contentHeader: "Vesting",
    path: MANAGE_PLAN_ROUTES.ADD_VESTING,
    breadCrumbs: [
      {
        label: "Add Vesting",
        link: MANAGE_PLAN_ROUTES.ADD_VESTING,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.VESTING,
    contentHeader: "Additonal Vesting",
    path: MANAGE_PLAN_ROUTES.ADD_VESTING_RULE,
    breadCrumbs: [
      {
        label: "Add Vesting Rule",
        link: MANAGE_PLAN_ROUTES.ADD_VESTING,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.FUNDING,
    path: MANAGE_PLAN_ROUTES.MANAGE_FUNDING_DETAIL,

    contentHeader: "Funding",

    breadCrumbs: [
      {
        label: "Manage Fundings",

        link: MANAGE_PLAN_ROUTES.MANAGE_FUNDING,
      },
    ],

    childRoutes: [],
  },

  {
    id: REVIEW_SCREEN_DATA_MAPPING.ENROLLMENT,

    contentHeader: "Enrollment",

    path: MANAGE_PLAN_ROUTES.ENROLLMENT,

    breadCrumbs: [
      {
        label: "Enrollment",

        link: MANAGE_PLAN_ROUTES.ENROLLMENT,
      },
    ],
  },

  {
    id: REVIEW_SCREEN_DATA_MAPPING.ENROLLMENT,

    contentHeader: "Add Source Enrollment",

    contentHeader: "Enrollment1",
    path: MANAGE_PLAN_ROUTES.ENROLLMENT1,
    breadCrumbs: [
      {
        label: "Enrollment1",
        link: MANAGE_PLAN_ROUTES.ENROLLMENT1,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ENTRYDATE,
    contentHeader: "Add Source Entry Date",
    path: MANAGE_PLAN_ROUTES.SOURCE_ENROLLMENT,

    breadCrumbs: [
      {
        label: "EntryDate",
        link: MANAGE_PLAN_ROUTES.ENTRYDATE,
      },
    ],
  },

  {
    id: REVIEW_SCREEN_DATA_MAPPING.ROLLOVER,

    contentHeader: "Additional Auto Enrollment",
    path: MANAGE_PLAN_ROUTES.ADDITIONAL_AUTO_ENROLLMENT,
    breadCrumbs: [
      {
        label: "Enrollment",
        link: MANAGE_PLAN_ROUTES.ENROLLMENT,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.ROLLOVER,

    contentHeader: "Rollovers",

    path: MANAGE_PLAN_ROUTES.ROLLOVER,

    breadCrumbs: [
      {
        label: "Rollovers",

        link: MANAGE_PLAN_ROUTES.ROLLOVER,
      },
    ],
  },

  {
    id: REVIEW_SCREEN_DATA_MAPPING.COMPENSATION,

    path: MANAGE_PLAN_ROUTES.MANAGE_SOURCE_COMPENSATION,

    contentHeader: "Add Source Compensation",

    breadCrumbs: [
      {
        label: "Compensation",

        link: MANAGE_PLAN_ROUTES.MANAGE_COMPENSATION,
      },
    ],

    childRoutes: [],
  },

  {
    id: REVIEW_SCREEN_DATA_MAPPING.DISTRIBUTIONS,

    path: MANAGE_PLAN_ROUTES.DISTRIBUTIONS,

    contentHeader: "Distributions",

    breadCrumbs: [
      {
        label: "Distributions",

        link: MANAGE_PLAN_ROUTES.DISTRIBUTIONS,
      },
    ],

    childRoutes: [],
  },

  {
    id: REVIEW_SCREEN_DATA_MAPPING.DISTRIBUTIONS,

    path: MANAGE_PLAN_ROUTES.ADD_DISTRIBUTIONS,

    contentHeader: "Add Distribution",

    breadCrumbs: [
      {
        label: "Distributions",

        link: MANAGE_PLAN_ROUTES.DISTRIBUTIONS,
      },
    ],

    childRoutes: [],
  },

  {
    id: REVIEW_SCREEN_DATA_MAPPING.LOANS,

    path: MANAGE_PLAN_ROUTES.LOANS,

    contentHeader: "Loans",

    breadCrumbs: [
      {
        label: "Loans",

        link: MANAGE_PLAN_ROUTES.LOANS,
      },
    ],

    childRoutes: [],
  },

  {
    id: REVIEW_SCREEN_DATA_MAPPING.INVESTMENTS,

    path: MANAGE_PLAN_ROUTES.MANAGE_INVESTMENTS_MASTER,

    contentHeader: "Manage Investments",

    breadCrumbs: [],

    childRoutes: [],
  },

  {
    id: REVIEW_SCREEN_DATA_MAPPING.INVESTMENTS,

    path: MANAGE_PLAN_ROUTES.ADD_INVESTMENTS,

    contentHeader: "Add Investments",

    breadCrumbs: [
      {
        label: "Manage Investments",

        link: MANAGE_PLAN_ROUTES.MANAGE_INVESTMENTS_PLAN,
      },
    ],

    childRoutes: [],
  },

  {
    id: REVIEW_SCREEN_DATA_MAPPING.INVESTMENTS,

    path: MANAGE_PLAN_ROUTES.ADD_INVESTMENTS_RESTRICTIONS,

    contentHeader: "Restrictions",

    breadCrumbs: [
      {
        label: "Manage Investments",

        link: MANAGE_PLAN_ROUTES.MANAGE_INVESTMENTS_PLAN,
      },
    ],

    childRoutes: [],
  },

  {
    id: REVIEW_SCREEN_DATA_MAPPING.LOANS,

    path: MANAGE_PLAN_ROUTES.ADD_LOANS,

    contentHeader: "Add Loan",

    breadCrumbs: [
      {
        label: "Loan",

        link: MANAGE_PLAN_ROUTES.LOANS,
      },
    ],
  },
];

export const managePlanFormNames = {
  CREATE_PLAN: "create_plan",
  ADD_SPONSOR_MANAGE_PLAN: "Add_sponsor",
  BASIC_DETAILS_MANAGE_PLAN: "Basic_Details",
  ADD_TRUSTEE_MANAGE_PLAN: "Add_trustee",
  ADD_CUSTODIAN_MANAGE_PLAN: "Add_custodian",
  ADD_ADVISOR_MANAGE_PLAN: "Add_advisor",
  ADD_COMPLIANCE: "Add_compliance",
  ADD_ELIGIBILITY: "Add_Eligibility",
  ADDITIONAL_ELIGIBILITY_RULE: "Additional_Eligibility_Rule",
  BASIC_SOURCES: "basicsources_plan",
  SOURCES_ADDITIONAL_RULES: "sourcesadditinalrules_plan",
  ALLOCATION: "allocation",
  SOURCES_ALLOCATION: "sources_allocation",
  YEARS_OF_SERVICE: "yearsOfService",
  ADD_VESTING: "add_vesting",
  ADD_VESTING_RULE: "add_vesting_rule",
  FUNDING_DETAIL: "fundings_plan",
  ADD_ENROLLMENT: "add_enrollment",
  ENROLLMENT_DETAIL_REPORT: "enrollment_detail_report",
  ADD_AUTO_ENROLLMENT: "auto_enrollment",
  ADD_ADDITIONAL_AUTO_ENROLLMENT: "additional_auto_enrollment",
  ADD_SOURCE_ENROLLMENT: "add_source_enrollment",
  ADD_ROLLOVERS: "add_rollovers",
  MANAGE_RETIREMENT: "manageretirement_plan",
  MANAGE_COMPENSATION: "managecompensation_plan",
  MANAGE_PLAN_COMPENSATION_CATEGORY: "plancompensationcategory_plan",
  MANAGE_SOURCE_COMPENSATION: "managesourcecompensation_plan",
  ADD_DISTRIBUTIONS: "add_distributions",
  ADD_TRANSFER: "add_transfer",
  ADD_INVESTMENT: "add_investment",
  ADD_INVESTMENT_RESTRICTIONS: "add_investment_restrictions",
  ADD_LOANS: "add loans",
  PLAN_INVESTMENT_FILTER: "plan_investment_filter",
  ADD_ENTRYDATECLASSIFICATION: "add_entryDateClassification",
  ADDITIONAL_ENTRYDATECLASSIFICATION_RULE:
    "additional_entryDateClassification_rule",
};

export const planFormFields = {
  [managePlanFormNames.CREATE_PLAN]: {
    category: "category",
    planType: "planType",
    prototype: "prototype",
    companyId: "companyId",
    companyName: "companyName",
    planGroup: "planGroup",
    planName: "planName",
    rkPlanNumber: "rkPlanNumber",
    level: "level",
    AECompany: "AECompany",
    mepPlanId: "mEPPlanId",
    mepPlanName: "mepPlanName",
    sponsoringOrganisation: "sponsoringOrganisation",
    sponsoringOrganisationId: "sponsoringOrganisationId",
    effectiveDate: "effectiveDate",
    recordKeeperName: "recordKeeperName",
  },
  [managePlanFormNames.ADD_SPONSOR_MANAGE_PLAN]: {
    ssn: "ssn",
    firstName: "firstName",
    middleName: "middleName",
    lastName: "lastName",
    email: "email",
    mobilePhoneNumber: "mobilePhoneNumber",
    workPhoneNumber: "workPhoneNumber",
    website: "website",
  },
  [managePlanFormNames.BASIC_DETAILS_MANAGE_PLAN]: {
    planName: "planName",
    startDate: "startDate",
    endDate: "endDate",
    yearStartMonth: "yearStartMonth",
    yearStartDate: "yearStartDate",
    yearEndMonth: "yearEndMonth",
    yearEndDate: "yearEndDate",
    effectiveDate: "effectiveDate",
    planTerminationDate: "planTerminationDate",
    shortYearIndicator: "shortYearIndicator",
    shortYearStartDate: "shortYearStartDate",
    shortYearEndDate: "shortYearEndDate",
    irsPlanNumber: "irsPlanNumber",
    trsContractId: "trsContractId",
    name: "name",
    mobilePhoneNumber: "mobilePhoneNumber",
    email: "email",
    planAdministratorId: "planAdministratorId",
    planAdministrator: "planAdministrator",
    rkPlanNumber: "rkPlanNumber",
    companyName: "CompanyName",
    masterPlanId: "MasterPlanId",
    planId: "PlanId",
    indicator316: "indicator316",
  },
  [managePlanFormNames.ADD_TRUSTEE_MANAGE_PLAN]: {
    trusteeCompanyName: "trusteeCompanyName",
    email: "email",
    mobilePhoneNumber: "mobilePhoneNumber",
    workPhoneNumber: "workPhoneNumber",
    website: "website",
    level: "level",
    addToMaster: "addToMaster",
  },
  [managePlanFormNames.ADD_CUSTODIAN_MANAGE_PLAN]: {
    custodianCompanyName: "custodianCompanyName",
    email: "email",
    mobilePhoneNumber: "mobilePhoneNumber",
    workPhoneNumber: "workPhoneNumber",
    website: "website",
    level: "level",
    addToMaster: "addToMaster",
  },
  [managePlanFormNames.ADD_ADVISOR_MANAGE_PLAN]: {
    advisorCompanyName: "advisorCompanyName",
    email: "email",
    mobilePhoneNumber: "mobilePhoneNumber",
    workPhoneNumber: "workPhoneNumber",
    website: "website",
    level: "level",
    addToMaster: "addToMaster",
  },
  [managePlanFormNames.ADD_COMPLIANCE]: {
    testingType: "testingType",
    testingMethod: "testingMethod",
    hceIndicator: "hceIndicator",
    qmac: "qmac",
    qnec: "qnec",
    safeHarbourIndicator: "safeHarbourIndicator",
    form5500DueDate: "form5500DueDate",
    month: "month",
    day: "day",
  },
  [managePlanFormNames.ADD_ELIGIBILITY]: {
    eligibilityRuleFor: "eligibilityRuleFor",
    eligibilityName: "name",
    eligibilityDescription: "description",
    exclusionType: "exclusionType",
    hire: "hire",
    startDate: "startDate",
    endDate: "endDate",
    immediateEligibility: "immediateEligibility",
    employeePopulation: "isRevaluationRequired",
    isBreakInService: "isBreakInService",
    applicableEligibilityRequirement: "eligibilityType",
    yearsOfServiceDefinition: "yearsOfServiceDefinition",
    otherComputationalMonths: "months",
    eligibilityOption: "eligibilityOption",
    age: "age",
    ageMonth: "ageMonth",
    planAmendmentId: "planAmendmentId",
    amendmentTitle: "amendmentTitle",
    amendmentEffectiveDate: "amendmentEffectiveDate",
    amendmentDescription: "amendmentDescription",
    amendmentStartDate: "amendmentStartDate",
    directAmendment: "directAmendment",
    hours: "hours",
    activeEmployee: "activeEmployee",
    disabledEmployee: "disabledEmployee",
    deceasedEmployee: "deceasedEmployee",
    retiredEmployee: "retiredEmployee",
    daily: "dailyHours",
    weekly: "weeklyHours",
    biweekly: "biWeeklyHours",
    semiMonthly: "semiMonthlyHours",
    monthly: "monthlyHours",
    quarterly: "quarterlyHours",
    semiAnnually: "semiAnnuallyHours",
    annually: "annuallyHours",
    eligibilityCalculationPeriod: "eligibilityCalculationPeriod",
    yearsOfServiceRequirement: "yearsOfServiceRequirement",
    serviceCreditPeriod: "serviceCreditPeriod",
    serviceCreditDay: "serviceCreditDay",
    consecutiveBreaksInService: "consecutiveBreaksInService",
    breakInServiceDefinition: "breakInServiceDefinition",
    sourceEligibilities: "sourceEligibilities",
    hiredOnOrAfterDate: "hiredOnOrAfterDate",
    hiredOnOrBeforeDate: "hiredOnOrBeforeDate",
    // lengthOfServiceRequirement: "lengthOfServiceRequirement",
    monthsYearDropdown: "monthsYearDropdown",
    lengthOfService: "lengthOfService",
    period: "period",
    eligibilityRequirementMetDate: "eligibilityRequirementMetDate",
    eligibilityBreakInServices: "eligibilityBreakInServices",
    additionalEligibilityRules: "additionalEligibilityRules",
    excludedClassifications: "excludedClassifications",
    isLTPTApplicable: "isLTPTApplicable",
    ltptAgeInYears: "ltptAgeInYears",
    ltptAgeInMonths: "ltptAgeInMonths",
    ltptHours: "ltptHours",
    consecutiveYears: "consecutiveYears",
    ltptVestingComputationPeriod: "ltptVestingComputationPeriod",
    ltptServiceCreditPeriod: "ltptServiceCreditPeriod",
    applicableEmployeeSourceForLTPT: "applicableEmployeeSourceForLTPT",
    effectiveDate: "effectiveDate",
  },
  [managePlanFormNames.ADDITIONAL_ELIGIBILITY_RULE]: {
    excludedClassifications: "excludedClassifications",
    eligibilityDescription: "description",
    effectiveStartDate: "effectiveStartDate",
    effectiveEndDate: "effectiveEndDate",
    exclusionType: "exclusionType",
    hours: "hours",
    otherComputationalMonths: "months",
    applicableEligibilityRequirement: "eligibilityType",
    age: "age",
    ageMonth: "ageMonth",
    yearsOfServiceDefinition: "yearsOfServiceDefinition",
    eligibilityOption: "eligibilityOption",
    hireDateType: "hireDateType",
    startDate: "startDate",
    endDate: "endDate",
    daily: "dailyHours",
    weekly: "weeklyHours",
    biweekly: "biWeeklyHours",
    semiMonthly: "semiMonthlyHours",
    monthly: "monthlyHours",
    quarterly: "quarterlyHours",
    semiAnnually: "semiAnnuallyHours",
    annually: "annuallyHours",
    eligibilityCalculationPeriod: "eligibilityCalculationPeriod",
    yearsOfServiceRequirement: "yearsOfServiceRequirement",
    serviceCreditPeriod: "serviceCreditPeriod",
    serviceCreditDay: "serviceCreditDay",
    consecutiveBreaksInService: "consecutiveBreaksInService",
    breakInServiceDefinition: "breakInServiceDefinition",
    sourceEligibilities: "sourceEligibilities",
    startHireDate: "startHireDate",
    endHireDate: "endHireDate",
    period: "period",
    eligibilityRequirementMetDate: "eligibilityRequirementMetDate",
    exclusionRuleId: "exclusionRuleId",
    monthsYearDropdown: "monthsYearDropdown",
    lengthOfService: "lengthOfService",
    immediateEligibility: "immediateEligibility",
    employeePopulation: "employeePopulation",
    isBreakInService: "isBreakInService",
    isLTPTApplicable: "isLTPTApplicable",
    ltptAgeInYears: "ltptAgeInYears",
    ltptAgeInMonths: "ltptAgeInMonths",
    ltptHours: "ltptHours",
    consecutiveYears: "consecutiveYears",
    ltptVestingComputationPeriod: "ltptVestingComputationPeriod",
    ltptServiceCreditPeriod: "ltptServiceCreditPeriod",
    applicableEmployeeSourceForLTPT: "applicableEmployeeSourceForLTPT",
    effectiveDate: "effectiveDate",
  },
  [managePlanFormNames.BASIC_SOURCES]: {
    sourceType: "sourceType",
    sourceCategory: "sourceCategory",
    sourceSubCategory: "sourceSubCategory",
    sourceSubSubCategory: "sourceSubSubCategory",
    sourceName: "sourceName",
    recordKeepingNumber: "recordKeepingNumber",
    effectiveStartDate: "effectiveStartDate",
    effectiveEndDate: "effectiveEndDate",
    isNewContributionAllowed: "isNewContributionAllowed",
    isDisplayToParticipantWebsite: "isDisplayToParticipantWebsite",
    isContributionManatory: "isContributionManatory",
    contributionType: "contributionType",
    limitMinimumDollar: "limitMinimumDollar",
    limitMaximumDollar: "limitMaximumDollar",
    maximumDollarCompensation: "maximumDollarCompensation",
    rehireDeferralPercentage: "rehireDeferralPercentage",
    contributionMethod: "contributionMethod",
    allocationPercForRehires: "allocationPercForRehires",
    otherPercForRehires: "otherPercForRehires",
    shouldEnrollInAdiProgramme: "shouldEnrollInAdiProgramme",
    adiApplicableTo: "adiApplicableTo",
    periodOfIncrease: "periodOfIncrease",
    autoDeferralIncrease: "autoDeferralIncrease",
    maximumADI: "maximumADI",
    subjectToAutoEnrollment: "subjectToAutoEnrollment",
    defaultContributionForAutoEnrollment:
      "defaultContributionForAutoEnrollment",
    enrollmentType: "enrollmentType",
    responsibleMode: "responsibleMode",
    eligiblePaymentType: "eligiblePaymentType",
    employerContributionType: "employerContributionType",
    percentageOfCompensation: "percentageOfCompensation",
    periodForCalculation: "periodForCalculation",
    periodForMatchCalculation: "periodForMatchCalculation",
    sourceOfMatch: "sourceOfMatch",
    isSafeHarbourMatch: "isSafeHarbourMatch",
    isMaximumLimitApplicable: "isMaximumLimitApplicable",
    maximumDollarLimit: "maximumDollarLimit",
    isCalculationSuspended: "isCalculationSuspended",
    isCatchApplicable: "isCatchApplicable",
    isTrueUpApplicable: "isTrueUpApplicable",
    isThresholdApplicable: "isThresholdApplicable",
    safeHarbourType: "safeHarbourType",
    enhancedshMatchPercentage: "enhancedshMatchPercentage",
    uptoPercentageOfDeferral: "uptoPercentageOfDeferral",
    percentageOfCalculation: "percentageOfCalculation",
    percentageOfCompensationMatched: "percentageOfCompensationMatched",
    firstTierMatchPercent: "firstTierMatchPercent",
    secondTierMatchPercent: "secondTierMatchPercent",
    thirdTierMatchPercent: "thirdTierMatchPercent",
    firstTierCompensationMatchPercent: "firstTierCompensationMatchPercent",
    secondTierCompensationMatchPercent: "secondTierCompensationMatchPercent",
    thirdTierCompensationMatchPercent: "thirdTierCompensationMatchPercent",
    employeeGroupsApplicable: "employeeGroupsApplicable",
    qmacType: "qmacType",
    qmacBefore1989: "qmacBefore1989",
    qnecBefore1989: "qnecBefore1989",
    additionalDeferralSource: "additionalDeferralSource",
    isLastDayRuleApplicable: "isLastDayRuleApplicable",
    employmentStatus: "employmentStatus",
    additionalMatchSources: "additionalMatchSources",
    additionalDiscretionarySources: "additionalDiscretionarySources",
    isNonPayPeriodApplicable: "isNonPayPeriodApplicable",
    isIncludeDefferals: "isIncludeDefferals",
    isIncludePlanCompensation: "isIncludePlanCompensation",
    isLastDayRule: "isLastDayRule",
    isHoursRequirement: "isHoursRequirement",
    hours: "hours",
    isNormalRetirement: "isNormalRetirement",
    isEarlyRetirement: "isEarlyRetirement",
    isDeath: "isDeath",
    isDisability: "isDisability",
  },
  [managePlanFormNames.SOURCES_ADDITIONAL_RULES]: {
    isContributionManatory: "isContributionManatory",
    contributionType: "contributionType",
    limitMaximumDollar: "limitMaximumDollar",
    limitMinimumDollar: "limitMinimumDollar",
    maximumDollarCompensation: "maximumDollarCompensation",
    rehireDeferralPercentage: "rehireDeferralPercentage",
    allocationPercForRehires: "allocationPercForRehires",
    shouldEnrollInAdiProgramme: "shouldEnrollInAdiProgramme",
    adiApplicableTo: "adiApplicableTo",
    periodOfIncrease: "periodOfIncrease",
    autoDeferralIncrease: "autoDeferralIncrease",
    maximumADI: "maximumADI",
    subjectToAutoEnrollment: "subjectToAutoEnrollment",
    defaultContributionForAutoEnrollment:
      "defaultContributionForAutoEnrollment",
    enrollmentType: "enrollmentType",
    allocationForumlaDesc: "allocationFormulaDescription",
    allocationEffectiveStartDate: "allocationEffectiveStartDate",
    allocationEffectiveEndDate: "allocationEffectiveEndDate",
    allocationFormulaAppliesTo: "allocationFormulaAppliesTo",
    availableEmployeeClassifications: "availableEmployeeClassifications",
    employerContributionType: "employerContributionType",
    percentageOfCompensation: "percentageOfCompensation",
    periodForCalculation: "periodForCalculation",
    periodForMatchCalculation: "periodForMatchCalculation",
    sourceType: "sourceType",
    sourceCategory: "sourceCategory",
    sourceSubCategory: "sourceSubCategory",
    sourceName: "sourceName",
    recordKeepingNumber: "recordKeepingNumber",
    effectiveStartDate: "effectiveStartDate",
    isNewContributionAllowed: "isNewContributionAllowed",
    isDisplayToParticipantWebsite: "isDisplayToParticipantWebsite",
    contributionMethod: "contributionMethod",
    otherPercForRehires: "otherPercForRehires",
    responsibleMode: "responsibleMode",
    eligiblePaymentType: "eligiblePaymentType",
    sourceOfMatch: "sourceOfMatch",
    isSafeHarbourMatch: "isSafeHarbourMatch",
    isCalculationSuspended: "isCalculationSuspended",
    isCatchApplicable: "isCatchApplicable",
    isTrueUpApplicable: "isTrueUpApplicable",
    safeHarbourType: "safeHarbourType",
    enhancedshMatchPercentage: "enhancedshMatchPercentage",
    uptoPercentageOfDeferral: "uptoPercentageOfDeferral",
    percentageOfCalculation: "percentageOfCalculation",
    percentageOfCompensationMatched: "percentageOfCompensationMatched",
    firstTierMatchPercent: "firstTierMatchPercent",
    secondTierMatchPercent: "secondTierMatchPercent",
    thirdTierMatchPercent: "thirdTierMatchPercent",
    firstTierCompensationMatchPercent: "firstTierCompensationMatchPercent",
    secondTierCompensationMatchPercent: "secondTierCompensationMatchPercent",
    thirdTierCompensationMatchPercent: "thirdTierCompensationMatchPercent",
    employeeGroupsApplicable: "employeeGroupsApplicable",
    qmacType: "qmacType",
    qmacBefore1989: "qmacBefore1989",
    qnecBefore1989: "qnecBefore1989",
    isLastDayRuleApplicable: "isLastDayRuleApplicable",
  },
  [managePlanFormNames.ALLOCATION]: {
    increments: "increments",
    frequencyOfIncrements: "frequencyOfIncrements",
    frequencyOfChanges: "frequencyOfChanges",
    doesInvestmentAllocationDifferBySource:
      "doesInvestmentAllocationDifferBySource",
    doesInvestmentsApplicableDifferBySource:
      "doesInvestmentsApplicableDifferBySource",
  },
  [managePlanFormNames.SOURCES_ALLOCATION]: {
    sourceName: "sourceName",
    sourceId: "sourceId",
    allocationIncrement: "allocationIncrement",
    frequencyAllocationChanges: "frequencyOfChange",
    investments: "investments",
  },
  [managePlanFormNames.ADD_VESTING]: {
    vestingName: "vestingName",
    vestingDescription: "vestingDescription",
    usePlanDefaultYOSIndicator: "usePlanDefaultYOSIndicator",
    yearsOfServiceExcludedIndicator: "yearsOfServiceExcludedIndicator",
    excludedYears: "excludedYears",
    vestingAgeLimit: "vestingAgeLimit",
    immediateVestingIndicator: "immediateVestingIndicator",
    vestingMethod: "vestingMethod",
    vestedAt: "vestedAt",
    hoursOfService: "hoursOfService",
    elapsedTime: "elapsedTime",
    vestingComputationalPeriod: "vestingComputationalPeriod",
    serviceCreditPeriod: "serviceCreditPeriod",
    vestingSchedule: "vestingSchedule",
    employerSourcesList: "employerSourcesList",
    forfeitureTimings: "forfeitureTimings",
    forfeitureFundIn: "forfeitureFundIn",
    forfeitureTreatment: "forfeitureTreatment",
    defaultInvestmentId: "defaultInvestmentId",
    breakInServiceApplicable: "breakInServiceApplicable",
    breakInServiceRules: "breakInServiceRules",
    hours: "hours",
    disregardYearsOfServiceAfterHowManyBreakInService:
      "disregardYearsOfServiceAfterHowManyBreakInService",
    freezeVestingPercentageAfterHowManyBreakInService:
      "freezeVestingPercentageAfterHowManyBreakInService",
    firstYear: "firstYear",
    secondYear: "secondYear",
    thirdYear: "thirdYear",
    fourthYear: "fourthYear",
    fifthYear: "fifthYear",
    disregardPrior: "disregardPrior",
    months: "months",
    breakInServiceRules: "breakInServiceRules",
    vestingPastPeriodComputation: "vestingPastPeriodComputation",
    activeEmployees: "activeEmployees",
    daily: "daily",
    weekly: "weekly",
    biWeekly: "biWeekly",
    semiMonthly: "semiMonthly",
    monthly: "monthly",
    quarterly: "quarterly",
    semiAnnually: "semiAnnually",
    annually: "annually",
    applyToAllStatuses: "applyToAllStatuses",
  },
  [managePlanFormNames.ADD_VESTING_RULE]: {
    vestingDescription: "vestingDescription",
    vestingOption: "vestingOption",
    additionalVestingDescription: "additionalVestingDescription",
    hirePeriod: "hirePeriod",
    hireStartDate: "hireStartDate",
    hireEndDate: "hireEndDate",
    hireDate: "hireDate",
    participationPeriod: "participationPeriod",
    participationStartDate: "participationStartDate",
    participationEndDate: "participationEndDate",
    participationDate: "participationDate",
    includedClassifications: "includedClassifications",
    immediateVestingIndicator: "immediateVestingIndicator",
    vestedAt: "vestedAt",
    vestingMethod: "vestingMethod",
    hoursOfService: "hoursOfService",
    elapsedTime: "elapsedTime",
    vestingComputationalPeriod: "vestingComputationalPeriod",
    serviceCreditPeriod: "serviceCreditPeriod",
    tablePercentage1: "tablePercentage1",
    tablePercentage2: "tablePercentage2",
    tablePercentage3: "tablePercentage3",
    tablePercentage4: "tablePercentage4",
    tablePercentage5: "tablePercentage5",
    vestingSchedule: "vestingSchedule",
    firstYear: "firstYear",
    secondYear: "secondYear",
    thirdYear: "thirdYear",
    fourthYear: "fourthYear",
    fifthYear: "fifthYear",
    disregardPrior: "disregardPrior",
    breakInServiceApplicable: "breakInServiceApplicable",
    hours: "hours",
    months: "months",
    breakInServiceRules: "breakInServiceRules",
    vestingPastPeriodComputation: "vestingPastPeriodComputation",
    activeEmployees: "activeEmployees",
    daily: "daily",
    weekly: "weekly",
    biWeekly: "biWeekly",
    semiMonthly: "semiMonthly",
    monthly: "monthly",
    quarterly: "quarterly",
    semiAnnually: "semiAnnually",
    annually: "annually",
    usePlanDefaultYOSIndicator: "usePlanDefaultYOSIndicator",
    applyToAllStatuses: "applyToAllStatuses",
  },
  [managePlanFormNames.FUNDING_DETAIL]: {
    bankAccountNumber: "bankAccountNumber",
    abaRoutingNumber: "abaRoutingNumber",
    bankAccountName: "bankAccountName",
    bankAccountType: "bankAccountType",
    bankAccountStatus: "bankAccountStatus",
    defaultBankAccountIndicator: "defaultBankAccountIndicator",
  },
  [managePlanFormNames.ENROLLMENT_DETAIL_REPORT]: {
    searchBySSNEmpIdName: "searchBySSNEmpIdName",
    enrollstatus: "enrollstatus",
    enrollsource: "enrollsource",
  },
  [managePlanFormNames.ADD_AUTO_ENROLLMENT]: {
    subjecttoAutoEnrollment: "subjecttoAutoEnrollment",
    minimumWithdrawallimit: "minimumWithdrawallimit",
    isAutoReEnroll: "isAutoReEnroll",
    isWindowPeriod: "isWindowPeriod",
    dateOfHire: "dateOfHire",
    hiredOnOrBeforeDateEnrollment: "hiredOnOrBeforeDateEnrollment",
    hiredOnOrAfterDateEnrollment: "hiredOnOrAfterDateEnrollment",
    hiredBetweenFrom: "hiredBetweenFrom",
    usePlanDefaultDeferralElection: "usePlanDefaultDeferralElection",
    usePlanDefaultInvestmentElection: "usePlanDefaultInvestmentElection",
    investmentsElection: "investmentsElection",
    hiredBetweenTo: "hiredBetweenTo",
    employmentStatus: "employmentStatus",
    frequencyOptoutIndicator: "frequencyOptoutIndicator",
    exclusionType: "exclusionType",
    excludedEmployeeClassifications: "excludedEmployeeClassifications",
    excludedEmploymentStatuses: "excludedEmploymentStatuses",
    sameInvestmentElectionToAllSources: "sameInvestmentElectionToAllSources",
    sameInvestmentElectionToAllParticipants:
      "sameInvestmentElectionToAllParticipants",
    numberOfDaysWindowIsOpenNumber: "numberOfDaysWindowIsOpenNumber",
    numberOfDaysWindowIsOpen: "numberOfDaysWindowIsOpen",
    numberOfDaysWindowIsOpenReEnrollmentNumber:
      "numberOfDaysWindowIsOpenReEnrollmentNumber",
    numberOfDaysWindowIsOpenReEnrollment:
      "numberOfDaysWindowIsOpenReEnrollment",
    investmentBasedOn: "investmentBasedOn",
    sameInvestmentBasedOn: "sameInvestmentBasedOn",
    birthDateFrom: "birthDateFrom",
    birthDateTo: "birthDateTo",
    RetirementDateFrom: "RetirementDateFrom",
    RetirementDateTo: "RetirementDateTo",
    InvestmentElectionBasedOnList: "InvestmentElectionBasedOnList",
  },

  [managePlanFormNames.ADD_ENROLLMENT]: {
    otherDescription: "otherDescription",
    additionalOtherDescription: "additionalOtherDescription",
    otherEntryDates: "otherEntryDates",
    additionalOtherEntryDates: "additionalOtherEntryDates",
    entryDateRule: "entryDateRule",
    isSwitchToPlanYearHaveDifferentEntryDates:
      "isSwitchToPlanYearHaveDifferentEntryDates",
    additionalEntryDateRule: "additionalEntryDateRule",
    prospectiveOrRetrospective: "prospectiveOrRetrospective",
    isCoincidingApplicable: "isCoincidingApplicable",
    additionalEntryDateRule: "additionalEntryDateRule",
    additionalProspectiveOrRetrospective:
      "additionalProspectiveOrRetrospective",
    isCoincidingApplicableForAdditional: "isCoincidingApplicableForAdditional",
    isAllSourcesFollowSameEntryDates: "isAllSourcesFollowSameEntryDates",
    autoDeferralIncreaseApplicableTo: "autoDeferralIncreaseApplicableTo",
    periodOfIncrease: "periodOfIncrease",
    applyADITo: "applyADITo",
    autoDeferralIncreaseProgram: "autoDeferralIncreaseProgram",
    exclusionType: "exclusionType",
    hiredBetweenFrom: "hiredBetweenFrom",
    hiredBetweenTo: "hiredBetweenTo",
    hiredOnOrBeforeDateEnrollment: "hiredOnOrBeforeDateEnrollment",
    hiredOnOrAfterDateEnrollment: "hiredOnOrAfterDateEnrollment",
    hiredOnOrBeforeDateAdditionalEnrollment:
      "hiredOnOrBeforeDateAdditionalEnrollment",
    hiredOnOrAfterDateAdditionalEnrollment:
      "hiredOnOrAfterDateAdditionalEnrollment",
    excludedEmploymentStatuses: "excludedEmploymentStatuses",
    excludedEmployeeClassifications: "excludedEmployeeClassifications",
    dateOfHire: "dateOfHire",
    sourceName: "sourceName",
    sourceContribution: "sourceContribution",
    investmentBasedOn: "investmentBasedOn",
    investmentsBasedOn: "investmentsBasedOn",
    sameInvestmentBasedOn: "sameInvestmentBasedOn",
    //Auto Enrollment fields
    subjecttoAutoEnrollment: "subjecttoAutoEnrollment",
    minimumWithdrawallimit: "minimumWithdrawallimit",
    isAutoReEnroll: "isAutoReEnroll",
    isWindowPeriod: "isWindowPeriod",
    dateOfHire: "dateOfHire",
    hiredOnOrBeforeDateEnrollment: "hiredOnOrBeforeDateEnrollment",
    hiredOnOrAfterDateEnrollment: "hiredOnOrAfterDateEnrollment",
    hiredBetweenFrom: "hiredBetweenFrom",
    usePlanDefaultDeferralElection: "usePlanDefaultDeferralElection",
    usePlanDefaultInvestmentElection: "usePlanDefaultInvestmentElection",
    investmentsElection: "investmentsElection",
    hiredBetweenTo: "hiredBetweenTo",
    employmentStatus: "employmentStatus",
    frequencyOptoutIndicator: "frequencyOptoutIndicator",
    exclusionType: "exclusionType",
    excludedEmployeeClassifications: "excludedEmployeeClassifications",
    excludedEmploymentStatuses: "excludedEmploymentStatuses",
    sameInvestmentElectionToAllSources: "sameInvestmentElectionToAllSources",
    sameInvestmentElectionToAllParticipants:
      "sameInvestmentElectionToAllParticipants",
    numberOfDaysWindowIsOpenNumber: "numberOfDaysWindowIsOpenNumber",
    numberOfDaysWindowIsOpen: "numberOfDaysWindowIsOpen",
    numberOfDaysWindowIsOpenReEnrollmentNumber:
      "numberOfDaysWindowIsOpenReEnrollmentNumber",
    numberOfDaysWindowIsOpenReEnrollment:
      "numberOfDaysWindowIsOpenReEnrollment",
    investmentBasedOn: "investmentBasedOn",
    sameInvestmentBasedOn: "sameInvestmentBasedOn",
    birthDateFrom: "birthDateFrom",
    birthDateTo: "birthDateTo",
    RetirementDateFrom: "RetirementDateFrom",
    RetirementDateTo: "RetirementDateTo",
    InvestmentElectionBasedOnList: "InvestmentElectionBasedOnList",
    //OtherInformation Tab fields of Enrollment
    allowReallocation: "allowReallocation",
    reAllocationPeriod: "reAllocationPeriod",
    numberOfReallocationAllowed: "numberOfReallocationAllowed",
    sendEnrollmentInvite: "sendEnrollmentInvite",
    numberOfDaysBeforeEntryDate: "numberOfDaysBeforeEntryDate",
  },

  [managePlanFormNames.ADD_ADDITIONAL_AUTO_ENROLLMENT]: {
    enrollmentDescription: "enrollmentDescription",
    excludedEmploymentStatuses: "excludedEmploymentStatuses",
    excludedEmployeeClassifications: "excludedEmployeeClassifications",
    hiredBetweenFrom: "hiredBetweenFrom",
    hiredBetweenTo: "hiredBetweenTo",
    exclusionType: "exclusionType",
    //additionalEnrollmentOptions: "additionalEnrollmentOptions",
    enrollmentEffectiveStartDate: "enrollmentEffectiveStartDate",
    enrollmentEffectiveEndDate: "enrollmentEffectiveEndDate",
    dateOfHire: "dateOfHire",
    hiredOnOrBeforeDateAdditionalEnrollment:
      "hiredOnOrBeforeDateAdditionalEnrollment",
    hiredOnOrAfterDateAdditionalEnrollment:
      "hiredOnOrAfterDateAdditionalEnrollment",
    usePlanDefaultDeferralElection: "usePlanDefaultDeferralElection",
    usePlanDefaultInvestmentElection: "usePlanDefaultInvestmentElection",
    investmentsElection: "investmentsElection",
    sameInvestmentElectionToAllSources: "sameInvestmentElectionToAllSources",
    sameInvestmentElectionToAllParticipants:
      "sameInvestmentElectionToAllParticipants",
    investmentsBasedOn: "investmentsBasedOn",
    investmentBasedOn: "investmentBasedOn",
    sameInvestmentBasedOn: "sameInvestmentBasedOn",
    birthDateFrom: "birthDateFrom",
    birthDateTo: "birthDateTo",
    RetirementDateFrom: "RetirementDateFrom",
    RetirementDateTo: "RetirementDateTo",
  },

  [managePlanFormNames.ADD_SOURCE_ENROLLMENT]: {
    otherDescription: "otherDescription",
    additionalOtherDescription: "additionalOtherDescription",
    sourceEnrollmentOtherEntryDates: "sourceEnrollmentOtherEntryDates",
    additionalSourceEnrollmentOtherDates:
      "additionalSourceEnrollmentOtherDates",
    sourceId: "sourceId",
    prospectiveOrRetrospective: "prospectiveOrRetrospective",
    isCoincidingApplicable: "isCoincidingApplicable",
    additionalEntryDateRule: "additionalEntryDateRule",
    additionalProspectiveOrRetrospective:
      "additionalProspectiveOrRetrospective",
    isCoincidingApplicableForAdditional: "isCoincidingApplicableForAdditional",
    entryDateRule: "entryDateRule",
    planEntryDate: "planEntryDate",
    isSwitchToPlanYearHaveDifferentEntryDates:
      "isSwitchToPlanYearHaveDifferentEntryDates",
    additionalEntryDateRule: "additionalEntryDateRule",
  },
  [managePlanFormNames.ADD_ROLLOVERS]: {
    rollOversAllowed: "rollOversAllowed",
    rollOversAllowedPriorToDistribution: "rollOversAllowedPriorToDistribution",
    rollOversAllowedPriorToEligibility: "rollOversAllowedPriorToEligibility",
    rollOversAllowedPriorToLoans: "rollOversAllowedPriorToLoans",
    rollOversFee: "rollOversFee",
    approvalHierarchy: "approvalHierarchy",
    approval: "approval",
  },
  [managePlanFormNames.YEARS_OF_SERVICE]: {
    isPlanYOSApplicable: "isPlanYOSApplicable",
    serviceComputation: "serviceComputation",
    hoursOfService: "hoursOfService",
    elapsedTimeInMonths: "elapsedTimeInMonths",
    activeEmployeesHours: "activeEmployeesHours",
    semiMonthlyHours: "semiMonthlyHours",
    dailyHours: "dailyHours",
    weeklyHours: "weeklyHours",
    biWeeklyHours: "biWeeklyHours",
    monthlyHours: "monthlyHours",
    quarterlyHours: "quarterlyHours",
    semiAnnuallyHours: "semiAnnuallyHours",
    annuallyHours: "annuallyHours",
    computationPeriod: "computationPeriod",
    planYOSServiceCreditPeriod: "planYOSServiceCreditPeriod",
    applyToAllStatuses: "applyToAllStatuses",
  },
  [managePlanFormNames.MANAGE_RETIREMENT]: {
    earlyRetirement: "earlyRetirement",
    earlyAgeYears: "earlyAgeYears",
    earlyAgeMonths: "earlyAgeMonths",
    earlyServiceYears: "earlyServiceYears",
    earlyRetirementDateRule: "earlyRetirementDateRule",
    // earlyvestingRule: "earlyVestingId",
    // earlyYOSRule: "earlyYosRule",
    earlyParticipationYears: "earlyParticipationYears",
    normalRetirement: "normalRetirement",
    normalAgeYears: "normalAgeYears",
    normalAgeMonths: "normalAgeMonths",
    normalServiceYears: "normalServiceYears",
    normalRetirementDateRule: "normalRetirementDateRule",
    // normalvestingRule: "normalVestingId",
    // normalYOSRule: "normalYosRule",
    normalParticipationYears: "normalParticipationYears",
  },
  [managePlanFormNames.MANAGE_COMPENSATION]: {
    modeOfHoursAndCompensation: "modeOfHoursAndCompensation",
    definition: "definition",
    isDifferAtClassificationLevel: "isDifferAtClassificationLevel",
    isPreEntry: "isPreEntry",
    isPostSeverance: "isPostSeverance",
    calculationPeriod: "calculationPeriod",
    isDiffersForPlanSources: "isDiffersForPlanSources",
    categoryName: "name",
    employeeClassifications: "employeeClassifications",
    sourceEmployeeClassifications: "sourceEmployeeClassifications",
    calculationType: "calculationType",
  },
  [managePlanFormNames.MANAGE_PLAN_COMPENSATION_CATEGORY]: {
    compensationId: "compensationId",
    compensationCategoryId: "compensationCategoryId",
    name: "name",
    calculationType: "calculationType",
  },
  [managePlanFormNames.MANAGE_POST_SEVERANCE_COMPENSATION_CATEGORY]: {
    compensationId: "compensationId",
    compensationCategoryId: "compensationCategoryId",
    name: "name",
    calculationType: "calculationType",
  },

  [managePlanFormNames.MANAGE_EMPLOYEE_CLASSIFICATION_CATEGORY]: {
    compensationId: "compensationId",
    compensationName: "name",
  },
  [managePlanFormNames.MANAGE_COMPENSATION_CLASSIFICATION]: {
    employeeClasificationCategoryId: "employeeClasificationCategoryId",
    employeeClassificationCodeId: "employeeClassificationCodeId",
    codeValue: "codeValue",
  },
  [managePlanFormNames.MANAGE_COMPENSATION_CLASSIFICATION_CATEGORY]: {
    employeeClasificationCategoryId: "employeeClasificationCategoryId",
    compensationCategoryId: "compensationCategoryId",
    name: "name",
    calculationType: "calculationType",
  },
  [managePlanFormNames.MANAGE_SOURCE_COMPENSATION_CATEGORY]: {
    sourceCompensationId: "sourceCompensationId",
    compensationCategoryId: "compensationCategoryId",
    name: "name",
    calculationType: "calculationType",
  },
  [managePlanFormNames.MANAGE_SOURCE_COMPENSATION_CLASSIFICATION]: {
    sourceCompensationId: "sourceCompensationId",
    employeeClassificationCodeId: "employeeClassificationCodeId",
    codeValue: "codeValue",
  },
  [managePlanFormNames.MANAGE_SOURCE_COMPENSATION_CLASSIFICATION_CATEGORY]: {
    sourceCompensationId: "sourceCompensationId",
    compensationCategoryId: "compensationCategoryId",
    name: "name",
    calculationType: "calculationType",
  },
  [managePlanFormNames.MANAGE_SOURCE_COMPENSATION]: {
    compensationName: "compensationName",
    definition: "definition",
    isDifferAtClassificationLevel: "isDifferAtClassificationLevel",
    isPreEntry: "isPreEntry",
    isDiffersForPlanSources: "isDiffersForPlanSources",
    source_SourceCompensations: "source_SourceCompensations",
  },
  [managePlanFormNames.ADD_DISTRIBUTIONS]: {
    thresholdAmount: "thresholdAmount",
    distributionAllocationPaymentMethod: "distributionAllocationPaymentMethod",
    numberOfDaysAdmin: "numberOfDaysAdmin",
    numberOfDaysParticipant: "numberOfDaysParticipant",
    withDrawalType: "withDrawalType",
    withdrawalDescription: "withdrawalDescription",
    ageLimitApplicable: "ageLimitApplicable",
    restrictionTypes: "restrictionTypes",
    planYOS: "planYOS",
    years: "years",
    months: "months",
    waiveOffLimitApplicable: "waiveOffLimitApplicable",
    waiveOffLimitReason: "waiveOffLimitReason",
    waiveOffLimit: "waiveOffLimit",
    earlyWithdrawalPenalty: "earlyWithdrawalPenalty",
    minimumWithDrawalLimitAmount: "minimumWithDrawalLimitAmount",
    maximumWithDrawalLimitAmount: "maximumWithDrawalLimitAmount",
    withdrawalLimitPerPeriod: "withdrawalLimitPerPeriod",
    withdrawalLimitPerPeriodValue: "withdrawalLimitPerPeriodValue",
    numberOfWithdrawalAllowed: "numberOfWithdrawalAllowed",
    processLesserAmountIfMaximumIsNotAvailable:
      "processLesserAmountIfMaximumIsNotAvailable",
    spouseConsentRequired: "spouseConsentRequired",
    sponsorApprovalRequired: "sponsorApprovalRequired",
    availableToBeneficiaries: "availableToBeneficiaries",
    availableToAlternatePayees: "availableToAlternatePayees",
    allowOptingOutOfFederlWithholdingTax:
      "allowOptingOutOfFederlWithholdingTax",
    allowOptingOutOfStateWithholdingTax: "allowOptingOutOfStateWithholdingTax",
    allowChangingOfFederalWithholdingTax:
      "allowChangingOfFederalWithholdingTax",
    allowChangingOfStateWithholdingTax: "allowChangingOfStateWithholdingTax",
    dateOfAnnuityPayments: "dateOfAnnuityPayments",
    distributionAllocationMethod: "distributionAllocationMethod",
    periodicPaymentMethod: "periodicPaymentMethod",
    periodicPaymentApplicable: "periodicPaymentApplicable",

    paymentMethod: "paymentMethod",
    interestRate: "interestRate",
    excludedEmployeeClassifications: "excludedEmployeeClassifications",
    excludedEmploymentStatuses: "excludedEmploymentStatuses",
    distributionAllocationMethodAutoRMD: "distributionAllocationMethodAutoRMD",
    distributionAllocationMethodCommon: "distributionAllocationMethodCommon",
    distributionAllocationMethodOntimePayment:
      "distributionAllocationMethodOntimePayment",
    orderOfPeriodicPayment: "orderOfPeriodicPayment",
    maximumNumberOfDirectRolloverPayees: "maximumNumberOfDirectRolloverPayees",
    allowParticipantstoChooseFeesDeductedMethod:
      "allowParticipantstoChooseFeesDeductedMethod",
    feesToBeDeductedFrom: "feesToBeDeductedFrom",
    paymentMethod: "paymentMethod",
    eftFee: "eftFee",
    overnightExpressDeliveryFee: "overnightExpressDeliveryFee",
    withdrawalOneTimeOriginateFee: "withdrawalOneTimeOriginateFee",
    rollOverFee: "rollOverFee",
    recurringFee: "recurringFee",
    chargeSameFeeForEachPayment: "chargeSameFeeForEachPayment",
    recurringFeeApplicable: "recurringFeeApplicable",
    suspendedSources: "suspendedSources",
    otherHardshipReason: "otherHardshipReason",
    requiresInServiceWithdrawalPriorToHardshipRequest:
      "requiresInServiceWithdrawalPriorToHardshipRequest",
    requiresLoanRequestPriorToHardshipRequest:
      "requiresLoanRequestPriorToHardshipRequest",
    restrictNumberOfHardshipsInDefinedPeriod:
      "restrictNumberOfHardshipsInDefinedPeriod",
    restrictedPeriodValue: "restrictedPeriodValue",
    restrictedPeriodTypeFrequency: "restrictedPeriodTypeFrequency",
    maximumNoOfHardShips: "maximumNoOfHardShips",
    totalMaximumNoOfHardShips: "totalMaximumNoOfHardShips",
    lengthOfSuspensionApplicable: "lengthOfSuspensionApplicable",
    suspensionPeriodYears: "suspensionPeriodYears",
    suspensionPeriodMonths: "suspensionPeriodMonths",
    earlyWaiveOffLimit: "earlyWaiveOffLimit",
    minimumWithdrawalType: "minimumWithdrawalType",
    checkFees: "checkFees",
    hardshipWithdrawalFee: "hardshipWithdrawalFee",
    hardshipReason: "hardshipReason",
    paymentFrequencyApplicable: "paymentFrequencyApplicable",
    calculationMethods: "calculationMethods",
    calculationMethodsApplicable: "calculationMethodsApplicable",
    worksOnSaturday: "worksOnSaturday",
    worksOnSunday: "worksOnSunday",
    startDay: "startDay",
    firstBeginDay: "firstBeginDay",
    secondBeginDay: "secondBeginDay",
    startMonth: "startMonth",
    startMonthFirstQuarter: "startMonthFirstQuarter",
    startMonthFirstHalfYear: "startMonthFirstHalfYear",
    startDateMonth: "startDateMonth",
    startDateDay: "startDateDay",

    withdrawalDocumentType: "withdrawalDocumentType",
    documentDescription: "documentDescription",
    minimumWithdrawalLimitValue: "minimumWithdrawalLimitValue",
    defaultPaymentFrequnecyForAutoRMD: "defaultPaymentFrequnecyForAutoRMD",
    withdrawalSources: "withdrawalSources",
    unformattedWithdrawalSources: "unformattedWithdrawalSources",
    maximumNumberOfDirectRolloverPayees: "maximumNumberOfDirectRolloverPayees",
    approval: "approval",
  },
  [managePlanFormNames.ADD_TRANSFER]: {
    showProspectusWithFirstTransfer: "showProspectusWithFirstTransfer",
    showProsPectusWithEachTransfer: "showProsPectusWithEachTransfer",
    isTransferAllowed: "isTransferAllowed",
    typesPermitted: "typesPermitted",
    isFlexibleTransferAllowed: "isFlexibleTransferAllowed",
    rebalanceAllowed: "rebalanceAllowed",
    rebalanceTypesPermitted: "rebalanceTypesPermitted",
    isReallocationAllowed: "isReallocationAllowed",
    numberOfTransfersAllowed: "numberOfTransfersAllowed",
    transferFrequency: "transferFrequency",
    transfersCountStartsFrom: "transfersCountStartsFrom",
    rebalancingThreshold: "rebalancingThreshold",
    periodicRebalancingRequired: "periodicRebalancingRequired",
    rebalanceFrequency: "rebalanceFrequency",
    rebalancingDay: "rebalancingDay",
    firstRebalancingDate: "firstRebalancingDate",
    reallocationFrequency: "reallocationFrequency",
    reallocationLimit: "reallocationLimit",
    reAllocationOnCountStartsFrom: "reAllocationOnCountStartsFrom",
  },
  [managePlanFormNames.ADD_INVESTMENT]: {
    investmentId: "investmentId",
    includeInvestmentIn: "includeInvestmentIn",
    companyId: "companyId",
    type: "type",
    investmentCategory: "investmentCategory",
    accountType: "accountType",
    alias: "alias",
    advisors: "advisors",
    name: "name",
    description: "description",
    status: "status",
    suspendedFromDate: "suspendedFromDate",
    suspendedToDate: "suspendedToDate",
    inceptionDate: "inceptionDate",
    fundCode: "fundCode",
    fundFamily: "fundFamily",
    cusip: "cusip",
    sedol: "sedol",
    isin: "isin",
    ticker: "ticker",
    shareClass: "shareClass",
    typeOfEarnings: "typeOfEarnings",
    dividendType: "dividendType",
    dividendProcessingFrequency: "dividendProcessingFrequency",
    accuralFactor: "accuralFactor",
    dividendProcessingOption: "dividendProcessingOption",
    isInvestmentQDIA: "isInvestmentQDIA",
    volatility: "volatility",
    prospectusDeliveryMethod: "prospectusDeliveryMethod",
    frequencyOfProspectusDisclaimer: "frequencyOfProspectusDisclaimer",
    isEquityWashRuleApplicable: "isEquityWashRuleApplicable",
    competingFunds: "competingFunds",
    restrictedPeriod: "restrictedPeriod",
    restrictedPeriodValue: "restrictedPeriodValue",
    closureDate: "closureDate",
    riskType: "riskType",
    is100PercAllocated: "is100PercAllocated",
    isReallocationAllowed: "isReallocationAllowed",
    isRebalanceAllowed: "isRebalanceAllowed",
    isPeriodicRebalancing: "isPeriodicRebalancing",
    effectiveDate: "effectiveDate",
    rebalancingFrequency: "rebalancingFrequency",
    marketTimingRule: "marketTimingRule",
    excludeSaturday: "excludeSaturday",
    excludeSunday: "excludeSunday",
    startDay: "startDay",
    biWeeklyStartDate: "biWeeklyStartDate",
    firstBeginDay: "firstBeginDay",
    secondBeginDay: "secondBeginDay",
    startDate: "startDate",
    quarterlyStartMonth: "quarterlyStartMonth",
    halfYearlyStartMonth: "halfYearlyStartMonth",
    annuallyStartDate: "annuallyStartDate",
    annuallyStartMonth: "annuallyStartMonth",
    effectiveStartDate: "effectiveStartDate",
    effectiveEndDate: "effectiveEndDate",
    applicableInvestments: "applicableInvestments",
    applicableTypes: "applicableTypes",
    percentageElections: "percentageElections",
    postingRulesForSells: "postingRulesForSells",
    postingRulesForBuys: "postingRulesForBuys",
    //Trustee_custodian_details
    custodianId: "custodianId",
    custodianAccountId: "custodianAccountId",
    excludeInvestmentFrom: "excludeInvestmentFrom",
    clearanceTime: "clearanceTime",
  },
  [managePlanFormNames.ADD_LOANS]: {
    planId: "planId",
    isShared: "isShared",
    loanType: "loanType",
    masterLoanTypeId: "masterLoanTypeId",
    masterLoanType: "masterLoanType",
    loanDescription: "loanDescription",
    numberOfLoansAllowed: "numberOfLoansAllowed",
    loanPerPlanYear: "loanPerPlanYear",
    minimumAmount: "minimumAmount",
    maximumAmount: "maximumAmount",
    maximumAmountPercentageValue: "maximumAmountPercentageValue",
    maximumAmountOtherValue: "maximumAmountOtherValue",
    minimumLength: "minimumLength",
    maximumLengthYears: "maximumLengthYears",
    maximumLengthMonths: "maximumLengthMonths",
    sourceHierarchies: "sourceHierarchies",
    restrictedInvestments: "restrictedInvestments",
    spousalConsentRequired: "spousalConsentRequired",
    sponsorApprovalRequired: "sponsorApprovalRequired",
    refinancingAllowed: "refinancingAllowed",
    processingTimeForLoan: "processingTimeForLoan",
    firstRepaymentDateFallsAfter: "firstRepaymentDateFallsAfter",
    firstRepaymentDateFallsWithin: "firstRepaymentDateFallsWithin",
    applicablePaymentMethodsLoan: "applicablePaymentMethods",
    allowMultipleActiveLoans: "allowMultipleActiveLoans",
    waitingPeriodBetweenLoansPayoffAndLoanRequest:
      "waitingPeriodBetweenLoansPayoffAndLoanRequest",
    curePeriod: "curePeriod",
    curePeriodFixedNumberOfDays: "curePeriodFixedNumberOfDays",
    curePeriodFixedNumberOfDaysForEmployeeTermination:
      "curePeriodFixedNumberOfDaysForEmployeeTermination",
    curePeriodForEmployeeTermination: "curePeriodForEmployeeTermination",
    defaultMethod: "defaultMethod",
    loanReAmortizationAllowed: "loanReAmortizationAllowed",
    loanReAmortizationFee: "loanReAmortizationFee",
    numberOfLoanReAmotizationsAllowed: "numberOfLoanReAmortizationsAllowed",
    loanIncrementAmount: "loanIncrementAmount",
    minimumLoanRepaymentAmount: "minimumLoanRepaymentAmount",
    loanApportioningMethod: "loanApportioningMethod",
    isServiceRequirementApplicable: "isServiceRequirementApplicable",
    serviceRequirementForLoan: "serviceRequirementForLoan",
    serviceRequirementForLoanNumber: "serviceRequirementForLoanNumber",
    allowLoansIfAnotherLoanIsDelinquentDefaultDeemed:
      "allowLoansIfAnotherLoanIsDelinquentDefaultDeemed",
    loanInterestRate: "loanInterestRate",
    loanInterestRateValue: "loanInterestRateValue",
    allowParticipantsToChooseInterestRate:
      "allowParticipantsToChooseInterestRate",
    interestRateMinimum: "interestRateMinimum",
    interestRateMaximum: "interestRateMaximum",
    excludedEmployeeClassifications: "excludedEmployeeClassifications",
    excludedEmploymentStatuses: "excludedEmploymentStatuses",
    allowParticipantsToChooseLoanFeeType:
      "allowParticipantsToChooseLoanFeeType",
    loanFeeTypeDeductedFrom: "loanFeeTypeDeductedFrom",
    feesPaymentMethodsApplicable: "feesPaymentMethodsApplicable",
    checkFee: "checkFee",
    eftFees: "eftFees",
    overnightDeliveryFees: "overnightDeliveryFees",
    recurringLoanFees: "recurringLoanFees",
    timingOfRecurringLoanFee: "timingOfRecurringLoanFee",
    loanFeeAmount: "loanFeeAmount",
    numberOfSuspensionsPerLoanAllowed: "numberOfSuspensionsPerLoanAllowed",
    numberOfRefinancingAllowed: "numberOfRefinancingAllowed",
    loanRefinancingFee: "loanRefinancingFee",
    loansAllowed: "loansAllowed",
    daysForLoanDefaultingIndication: "daysForLoanDefaultingIndication",
    withdrawalBasis: "withdrawalBasis",
    firstRepaymentDateFallsAfter: "firstRepaymentDateFallsAfter",
    firstRepaymentDateFallsWithin: "firstRepaymentDateFallsWithin",
    approval: "approval",
    loanDocumentType: "loanDocumentType",
    loanApprovalHierarchy: "loanApprovalHierarchy",
    approvalHierarchy: "approvalHierarchy",
    documentDescription: "documentDescription",
  },
  [managePlanFormNames.ADD_INVESTMENT_RESTRICTIONS]: {
    effectiveStartDate: "effectiveStartDate",
    effectiveEndDate: "effectiveEndDate",
    applicableTypes: "applicableTypes",
  },
  [managePlanFormNames.PLAN_INVESTMENT_FILTER]: {
    search: "search",
    investmentType: "investmentType",
    advisors: "advisors",
    custodian: "custodian",
    investmentStatus: "investmentStatus",
  },
  [managePlanFormNames.ADD_ENTRYDATECLASSIFICATION]: {
    entryDateRuleType: "entryDateRuleType",
    entryDateRuleFor: "entryDateRuleFor",
    otherDescription: "otherDescription",
    additionalOtherDescription: "additionalOtherDescription",
    sourceEnrollmentOtherEntryDates: "sourceEnrollmentOtherEntryDates",
    additionalSourceEnrollmentOtherDates:
      "additionalSourceEnrollmentOtherDates",
    entryDateSources: "entryDateSources",
    prospectiveOrRetrospective: "prospectiveOrRetrospective",
    isCoincidingApplicable: "isCoincidingApplicable",
    additionalEntryDateRule: "additionalEntryDateRule",
    additionalProspectiveOrRetrospective:
      "additionalProspectiveOrRetrospective",
    isCoincidingApplicableForAdditional: "isCoincidingApplicableForAdditional",
    entryDateRule: "entryDateRule",
    planEntryDate: "planEntryDate",
    isSwitchToPlanYearHaveDifferentEntryDates:
      "isSwitchToPlanYearHaveDifferentEntryDates",
    ruleName: "ruleName",
    otherEntryDates: "otherEntryDates",
    planYearOtherEntryDates: "planYearOtherEntryDates",
    entryDateClassifications: "additionalEntryDateRules",
  },
  [managePlanFormNames.ADDITIONAL_ENTRYDATECLASSIFICATION_RULE]: {
    otherDescription: "otherDescription",
    additionalOtherDescription: "additionalOtherDescription",
    sourceEnrollmentOtherEntryDates: "sourceEnrollmentOtherEntryDates",
    additionalSourceEnrollmentOtherDates:
      "additionalSourceEnrollmentOtherDates",
    sourceId: "sourceId",
    prospectiveOrRetrospective: "prospectiveOrRetrospective",
    isCoincidingApplicable: "isCoincidingApplicable",
    additionalEntryDateRule: "additionalEntryDateRule",
    additionalProspectiveOrRetrospective:
      "additionalProspectiveOrRetrospective",
    isCoincidingApplicableForAdditional: "isCoincidingApplicableForAdditional",
    entryDateRule: "entryDateRule",
    entryDateOption: "entryDateOption",
    planEntryDate: "planEntryDate",
    isSwitchToPlanYearHaveDifferentEntryDates:
      "isSwitchToPlanYearHaveDifferentEntryDates",
    additionalEntryDateRule: "additionalEntryDateRule",
    ruleName: "ruleName",
    effectiveStartDate: "effectiveStartDate",
    effectiveEndDate: "effectiveEndDate",
    exclusionType: "exclusionType",
    entryDateClassifications: "entryDateClassifications",
    otherEntryDates: "otherEntryDates",
    planYearOtherEntryDates: "planYearOtherEntryDates",
  },
};
